/**
 * Onboarding paths per workspace (UX kit §03).
 */

import { WORKSPACE_LABELS } from './workspaceExperience';

export const ONBOARDING_STORAGE_KEY = 'aariyatalk_onboarding_complete';

export const WORKSPACE_PERSONAS = [
  {
    id: 'builder',
    icon: '🛠️',
    title: 'Builder / Developer',
    description: 'Build and experiment with AI voice agents, APIs, and integrations',
  },
  {
    id: 'business',
    icon: '🏢',
    title: 'Business owner',
    description: 'Automate customer calls for your business without code',
  },
  {
    id: 'agency',
    icon: '🤝',
    title: 'Agency / reseller',
    description: 'Deploy voice AI for multiple clients',
  },
  {
    id: 'enterprise',
    icon: '🏭',
    title: 'Enterprise team',
    description: 'Large-scale operations, compliance, and team workflows',
  },
];

export const WORKSPACE_NEXT_STEP = {
  builder: {
    title: 'Start in the developer hub',
    description: 'Create an agent, run a web test call, then explore APIs and transcript streaming.',
    cta: 'Open developer hub',
    href: '/develop',
  },
  business: {
    title: 'Launch your first agent',
    description: 'Create an agent, add company knowledge, then connect your phone number.',
    cta: 'Create agent',
    href: '/agents',
  },
  agency: {
    title: 'Set up your first client agent',
    description: 'Create a template agent you can duplicate for each client.',
    cta: 'Create agent',
    href: '/agents',
  },
  enterprise: {
    title: 'Configure operations',
    description: 'Connect telephony, review call logs, and set up integrations for your team.',
    cta: 'Go to integrations',
    href: '/integrations',
  },
};

export const ACTIVATION_MILESTONES = [
  {
    id: 'agent',
    title: 'Create your first agent',
    description: 'Name, voice, and instructions',
    href: '/agents',
  },
  {
    id: 'test_call',
    title: 'Run a test call',
    description: 'Browser or phone test',
    href: '/testing',
  },
  {
    id: 'knowledge',
    title: 'Add company knowledge',
    description: 'Upload docs or URLs',
    href: '/knowledge',
  },
  {
    id: 'live',
    title: 'Go live on phone',
    description: 'Link telephony to your agent',
    href: '/telephony',
  },
];

export function getWorkspaceLabel(workspace) {
  return WORKSPACE_LABELS[workspace] || WORKSPACE_LABELS.business;
}

export function isOnboardingComplete() {
  try {
    return localStorage.getItem(ONBOARDING_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function setOnboardingComplete() {
  try {
    localStorage.setItem(ONBOARDING_STORAGE_KEY, 'true');
  } catch {
    /* ignore */
  }
}
